import { render, staticRenderFns } from "./ExclamTrian.vue?vue&type=template&id=fe55c43c&scoped=true&"
import script from "./ExclamTrian.js?vue&type=script&lang=js&"
export * from "./ExclamTrian.js?vue&type=script&lang=js&"
import style0 from "./ExclamTrian.vue?vue&type=style&index=0&id=fe55c43c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe55c43c",
  null
  
)

export default component.exports